// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GlassWallpaperColors} from '@app/features/theme/state/GlassTheme';
import styles from '@app/features/user/components/modals/tabs/appearance_tab/cards/ThemePreviewArt.module.css';
import {clsx} from 'clsx';
import type React from 'react';

export type ThemePreviewVariant = 'paper' | 'graphite' | 'glassLight' | 'glassDark' | 'system';

interface ThemePreviewArtProps {
	variant: ThemePreviewVariant;
	/** Wallpaper glows for the glass variants. */
	wallpaper?: GlassWallpaperColors;
}

function Mini({
	variant,
	wallpaper,
}: {
	variant: Exclude<ThemePreviewVariant, 'system'>;
	wallpaper?: GlassWallpaperColors;
}) {
	const glass = variant === 'glassLight' || variant === 'glassDark';
	const style =
		glass && wallpaper
			? ({'--pv-c1': wallpaper[0], '--pv-c2': wallpaper[1], '--pv-c3': wallpaper[2]} as React.CSSProperties)
			: undefined;
	return (
		<div className={clsx(styles.art, styles[variant])} style={style} aria-hidden="true">
			{glass && <div className={styles.wall} />}
			<div className={styles.rail}>
				<i />
				<i />
				<i />
				<i />
			</div>
			<div className={styles.list}>
				{[0, 1, 2, 3].map((index) => (
					<div key={index} className={styles.row}>
						<b />
						<s />
					</div>
				))}
			</div>
			<div className={styles.conv}>
				<div className={styles.bubble} />
				<div className={clsx(styles.bubble, styles.mine)} />
				<div className={styles.bubble} style={{width: '48%'}} />
				<div className={styles.composer} />
			</div>
		</div>
	);
}

/** A miniature Chats screen in a theme's colours. */
export function ThemePreviewArt({variant, wallpaper}: ThemePreviewArtProps) {
	if (variant === 'system') {
		return (
			<div className={styles.split} aria-hidden="true">
				<Mini variant="paper" />
				<Mini variant="graphite" />
			</div>
		);
	}
	return <Mini variant={variant} wallpaper={wallpaper} />;
}
